module.exports = __webpack_public_path__ + "static/media/walker.7ff30e43.svg";